import { useMutation as useMutationBase, } from '@tanstack/react-query';
import { request } from '../../request';
export function useMutation(query, endpoint, options, responseMapper = (response) => response) {
    return useMutationBase({
        mutationFn: async (variables) => {
            const response = await request({
                query,
                endpoint,
                variables,
            });
            return responseMapper(response);
        },
        ...options,
    });
}
;
//# sourceMappingURL=useMutation.js.map